<ng-container *skAutorun><div class="clean-data-content" #editorContainer></div></ng-container>